// 直播回放
const playback = () => import('@/pages/playback/playback.vue');
export default [
  {
    path: '/playback/:courseId/:chapterId/:resourceId/:openCourseId/:vid/',
    name: 'playback',
    component: playback,
    meta: {
      title: '回放',
      requireAuth: true,
    },
  },
];
